import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { interviewAvailabilityShape } from '../../../../../dateUtils';
import { deleteRequest } from '../../../../../requestUtils';
import { analyticsTrack } from '../../../../../analyticsUtils';
import InterviewAttendees from '../../../../common/InterviewSubComponents/InterviewAttendees';
import InterviewTimeRange from '../../../../common/InterviewSubComponents/InterviewTimeRange';
import InterviewTimezone from '../../../../common/InterviewSubComponents/InterviewTimezone';
import InterviewActions from '../../../../common/InterviewSubComponents/InterviewActions';
function PendingInterviewCard(_ref) {
  var interview = _ref.interview,
    possibleInterviewers = _ref.possibleInterviewers,
    invitableRoles = _ref.invitableRoles,
    consultantView = _ref.consultantView,
    csrfToken = _ref.csrfToken,
    editModalRef = _ref.editModalRef,
    canEdit = _ref.canEdit,
    canCancel = _ref.canCancel,
    onCancel = _ref.onCancel,
    interviewType = _ref.interviewType,
    availableInterviewSlotUrl = _ref.availableInterviewSlotUrl;
  var location = 'Proposal Page View';
  var copy = consultantView ? 'You have' : "".concat(interview.attendees.consultant.split(' ')[0], " has");
  var handleCancelInterview = function handleCancelInterview() {
    deleteRequest(interview.cancel_interview_path, csrfToken).then(function (response) {
      analyticsTrack('Interview cancelled; type: pending', location);
      onCancel(interview.id, response, 'pending');
    });
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "interview-info-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "interview-info-header upcoming"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "medium-weight mb-8"
  }, "Interview pending confirmation"), /*#__PURE__*/React.createElement("div", {
    className: "normal-weight body-text-2 mb-4"
  }, copy, ' ', "not selected a time yet. \xA0 All guests will be notified when a time is selected.")), /*#__PURE__*/React.createElement(InterviewAttendees, {
    attendees: interview.attendees,
    consultantView: consultantView
  }), /*#__PURE__*/React.createElement("hr", {
    className: "half-width"
  }), /*#__PURE__*/React.createElement("div", {
    className: "interview-availabilities-container body-text-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "interview-availabilities-header medium-weight mb-12"
  }, "Your availability for this interview:"), /*#__PURE__*/React.createElement("div", {
    className: "interview-availabilities-timezone normal-weight muted-gray-text mb-12"
  }, /*#__PURE__*/React.createElement(InterviewTimezone, {
    timezoneStr: interview.timezone
  })), /*#__PURE__*/React.createElement("div", {
    className: "interview-availabilities-list"
  }, interview.availabilities.map(function (availability) {
    return /*#__PURE__*/React.createElement(InterviewTimeRange, {
      interviewTime: availability,
      opts: {
        timeZone: 'UTC',
        weekday: 'long',
        month: 'short',
        day: 'numeric'
      },
      containerClassName: "interview-availability-item normal-weight mb-8",
      key: "".concat(availability.start_time).concat(availability.date)
    });
  })))), (canEdit || canCancel) && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(InterviewActions, {
    interview: interview,
    interviewType: interviewType,
    editInterviewPath: interview.edit_interview_path,
    csrfToken: csrfToken,
    possibleInterviewers: possibleInterviewers,
    invitableRoles: invitableRoles,
    editModalRef: editModalRef,
    canEdit: canEdit,
    canCancel: canCancel,
    location: "Proposal Page",
    onCancel: function onCancel() {
      return handleCancelInterview();
    },
    availableInterviewSlotUrl: availableInterviewSlotUrl
  })));
}
PendingInterviewCard.propTypes = {
  interview: PropTypes.shape({
    id: PropTypes.number.isRequired,
    round_number: PropTypes.number.isRequired,
    timezone: PropTypes.string.isRequired,
    attendees: PropTypes.shape({
      consultant: PropTypes.string,
      invitees: PropTypes.arrayOf(PropTypes.string),
      requester: PropTypes.string
    }).isRequired,
    availabilities: PropTypes.arrayOf(interviewAvailabilityShape),
    edit_interview_path: PropTypes.string.isRequired
  }).isRequired,
  possibleInterviewers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  invitableRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  editModalRef: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  canCancel: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  consultantView: PropTypes.bool.isRequired,
  csrfToken: PropTypes.string.isRequired,
  interviewType: PropTypes.string.isRequired,
  availableInterviewSlotUrl: PropTypes.string.isRequired
};
export default PendingInterviewCard;